
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 4 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"2","cy":"2","r":"2","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"2","cy":"8","r":"2","fill":"currentColor"}}),_c('circle',{attrs:{"cx":"2","cy":"14","r":"2","fill":"currentColor"}})])
          )
        }
      }
    